export default __webpack_public_path__ + "static/media/0xc778417e063141139fce010982780140aa0cd5ab.7f2a4365.svg";